import { Box, Typography } from "@mui/material";

interface BrandedFormHeaderProps {
  title: string;
  subtitle?: string;
}

// Cabeçalho da coluna de ação das telas Branded: título (h2, cor primary) + subtítulo
// curto opcional. Cores vêm do tema; sem hex, sem literal de marca.
export const BrandedFormHeader: React.FC<BrandedFormHeaderProps> = ({ title, subtitle }) => (
  <Box>
    <Typography
      variant="body1"
      component="h2"
      color="primary"
      sx={{ fontSize: "2.2rem", fontWeight: 700 }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography
        color="subTitles.main"
        sx={{ mt: 1, fontSize: "1.4rem", lineHeight: 1.5 }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);
